// extracted by mini-css-extract-plugin
module.exports = {"root":"SignUp_root__Mk8Op","formWidthContainer":"SignUp_formWidthContainer__XwfND","oinq":"SignUp_oinq___y9jG","oinqIn":"SignUp_oinqIn__chse9"};